import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import AssigneeDropdown from './AssigneeDropdown';
import Button from '../../../components/form/Button';
import { styles } from '../index';

const AssigneeBulkAssignDialog = function(props) {
    var open = props.open;
    var selectedCount = props.selectedCount;
    var assigneeId = props.assigneeId;
    var assignees = props.assignees;
    var onAssigneeChange = props.onAssigneeChange;
    var onConfirm = props.onConfirm;
    var onCancel = props.onCancel;

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>Přidělit zpracovatele</DialogTitle>
            <DialogContent>
                <div style={{ marginBottom: 16 }}>
                    Označeno {selectedCount} záznamů.
                </div>
                <AssigneeDropdown
                    assignees={assignees}
                    value={assigneeId}
                    onChange={onAssigneeChange}                
                />
            </DialogContent>
            <DialogActions>
                <Button
                    type="button"
                    style={{ ...styles.buttons, marginRight: 8 }}
                    label="Potvrdit"
                    onClick={onConfirm}
                />
                <Button
                    type="button"
                    style={styles.buttons}
                    label="Zpět"
                    onClick={onCancel}
                />
            </DialogActions>
        </Dialog>
    );
};

export default AssigneeBulkAssignDialog;